import { useEffect, useId, useRef, useState } from "react";
import { IconDownload, IconDeviceMobile, IconChevronRight } from "@tabler/icons-react";
import { usePwaInstallation } from "./PwaProvider.jsx";
import { installationSteps } from "./installation.js";
import "./installation.css";

export function InstallAppButton({ variant = "install" }) {
  const pwa = usePwaInstallation();
  const [helpOpen, setHelpOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const dialog = useRef(null);
  const titleId = useId();

  useEffect(() => {
    if (helpOpen) dialog.current?.showModal();
    else dialog.current?.close();
  }, [helpOpen]);

  if (!pwa || pwa.installed || window.Telegram?.WebApp?.initData) return null;

  async function install() {
    if (busy) return;
    if (!pwa.installPrompt) { setHelpOpen(true); return; }
    setBusy(true);
    try {
      await pwa.installPrompt.prompt();
      await pwa.installPrompt.userChoice;
    } catch {
      setHelpOpen(true);
    } finally {
      pwa.clearPrompt();
      setBusy(false);
    }
  }

  const profileRow = variant === "profile";
  return <section className={profileRow ? "pwa-profile-app" : "pwa-install"}>
    <button type="button" className={profileRow ? "pwa-app-row" : "pwa-install-button"} onClick={install} disabled={busy}>
      {profileRow ? <IconDeviceMobile size={28} stroke={1.7} aria-hidden="true" /> : <IconDownload size={20} aria-hidden="true" />}
      <span>{busy ? "Открываем установку…" : profileRow ? "Приложение" : "Установить MetaCard"}</span>
      {profileRow && <IconChevronRight size={28} stroke={1.7} aria-hidden="true" />}
    </button>
    {!profileRow && <p>Запускайте игру с главного экрана устройства.</p>}
    <dialog ref={dialog} className="pwa-install-dialog" aria-labelledby={titleId} onClose={() => setHelpOpen(false)}>
      <img src="/pwa/icon-192.png" width="64" height="64" alt="" />
      <h2 id={titleId}>MetaCard на вашем устройстве</h2>
      <ol>{installationSteps(navigator.userAgent, navigator.platform, navigator.maxTouchPoints).map(step => <li key={step}>{step}</li>)}</ol>
      <p>После запуска войдите по коду из бота. Карты и баланс останутся в вашем аккаунте. Для игры нужен интернет.</p>
      <button type="button" onClick={() => setHelpOpen(false)}>Понятно</button>
    </dialog>
  </section>;
}
